function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.67 26.84a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 16.65 19.5a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.67 24.57a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.67 26.84a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 16.65 19.5a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.67 24.57a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67 26.84a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 6.65 19.5a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67 24.57a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67 26.84a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 6.65 19.5a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67 24.57a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M2 23.09H0V15.5h77.67l-.1 4h-3.66l-.26 1.53-1.52-.12-.83-1.33-6-.09-.16-.75h-6.9l-13.71 2.94H20.36l-.09-.24a3.81 3.81 0 0 0-3.68-2.45 4.09 4.09 0 0 0-3.53 2.54l-.09.23h-2.75l-.1-.22a4.13 4.13 0 0 0-3.48-2.53h-.07a3.82 3.82 0 0 0-3.42 2.28l-.09.22H2v1.58zm-1.26-.71h.54v-1.6h1.31a4.57 4.57 0 0 1 4-2.5h.09a4.72 4.72 0 0 1 4 2.75h1.81a4.72 4.72 0 0 1 4.08-2.77 4.65 4.65 0 0 1 4.28 2.69h23.6l13.72-2.94h7.5l.17.76 5.87.08.85 1.36h.5l.25-1.48h3.6v-2.49H.72l.02 6.14z",
  fill: "#E4ECFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M76.49 16.02h-.72v3.11h.72v-3.11z",
  fill: "#E4ECFF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M76.13 16.58H.38v.72h75.75v-.72zM42.74 20.93h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM36.17 20.93h-1.26v-2.87h1.29l-.03 2.87zm-.93-.36h.57v-2.15h-.57v2.15zM29.59 20.93h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM23.02 20.93h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM12.19 20.93h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM58.59 20.35h-3v-1.7l3.07-.48-.07 2.18zm-2.33-.72h1.65v-.62l-1.62.25-.03.37z",
  fill: "#E4ECFF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M57.91 22.04h-1.6v-2.37h1.56l.04 2.37zm-.88-.72h.15v-1h-.13l-.02 1zM57.91 25.61h-1.59v-3h1.59v3zm-.87-.72h.15v-1.65h-.15v1.65z",
  fill: "#E4ECFF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M58.44 23.29h-2.75v-2h2.74l.01 2zm-2-.72h1.3v-.53h-1.3v.53zM58.42 26.14h-2.75v-1.27l2.75.02v1.25zM12 1V.6h-.339l-.056.334L12 1zm8.5 14-.299.266.12.134h.179V15zm3.5 0v.4h.175l.119-.129L24 15zm12 0-.294.271.119.129H36V15zm3.5 0v.4h.186l.12-.142L39.5 15zM51 15l-.294.271.119.129H51V15zm5 0v.4h.16l.115-.11L56 15zm9-8.5v-.4h-.159l-.116.11.275.29zm1 0v.4h.312l.076-.303L66 6.5zm.5-2 .388.097.033-.13-.053-.125-.368.158zM65 1l.368-.158L65.264.6H65V1zm-1 6.444-.275-.29.275.29zM14.887 8.605a.4.4 0 1 0-.606-.521l.606.521zm-.85-.964a.4.4 0 0 0-.613-.514l.612.514zm.302.428-.299.266.299-.266zm-1.898-2.187-.358.179.358-.18zm.147.217-.3.266.3-.266zm-1.034-2.42-.395-.066.394.066zm.091.612.358-.179-.357.179zm-.04-3.357-.446 2.68.79.131.446-2.68-.79-.13zm-.317 3.536.795 1.59.716-.357-.796-1.591-.715.358zM20.5 15.4H24v-.8h-3.5v.8zm3.794-.129 6-6.5-.588-.542-6 6.5.588.542zM30.4 8.5V1h-.8v7.5h.8zm-.694.271 6 6.5.588-.542-6-6.5-.588.542zM36 15.4h3.5v-.8H36v.8zm3.805-.142 5.5-6.5-.61-.516-5.5 6.5.61.516zM45.4 8.5V1h-.8v7.5h.8zM45 .6H30v.8h15V.6zm-.294 8.171 6 6.5.588-.542-6-6.5-.588.542zM51 15.4h5v-.8h-5v.8zm15.388-8.803.5-2-.776-.194-.5 2 .776.194zm.48-2.255-1.5-3.5-.736.316 1.5 3.5.736-.316zM65 .6h-3.5v.8H65V.6zm-3.5 0H45v.8h16.5V.6zm-5.225 14.69 5.5-5.194-.55-.581-5.5 5.194.55.582zM61.1 1v8.806h.8V1h-.8zm.675 9.096 2.5-2.36-.55-.582-2.5 2.36.55.582zm2.5-2.36 1-.945-.55-.582-1 .945.55.581zm-.611-.075 5.5 8.555.672-.432-5.5-8.556-.672.433zm1.248-.947 6 9.5.676-.428-6-9.5-.676.428zM65 6.9h.25v-.8H65v.8zm.25 0H66v-.8h-.75v.8zM8.303 16.26l6.584-7.655-.606-.521-6.584 7.655.606.522zm-1.497-.003 7.23-8.616-.612-.514-7.23 8.616.612.514zm5.483-9.892 1.751 1.97.598-.532-1.751-1.97-.598.532zm1.751 1.97 6.161 6.93.598-.53-6.161-6.932-.598.532zM30 .6H14.339v.8H30V.6zM14.339.6H12v.8h2.339V.6zm.4 7.469V1h-.8v7.069h.8zM12.083 6.06c.055.11.124.212.206.304l.598-.532a.598.598 0 0 1-.088-.13l-.716.358zm-.924-2.448a1.4 1.4 0 0 0 .129.857l.715-.358a.6.6 0 0 1-.055-.367l-.79-.132z",
  fill: "#E4ECFF"
});

var SvgPneumaticTrailer = function SvgPneumaticTrailer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 27,
    viewBox: "0 0 78 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPneumaticTrailer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pneumaticTrailer.e8e303ff.svg";
export { ForwardRef as ReactComponent };